import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const action1 = defineConnector({
  identifier: "action1",
  name: "Action1",
  tagLine: "Remote monitoring and management",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://app\\.action1\\.com/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://app.action1.com/api/3.0/oauth2/token",
        method: "POST",
        formBody: {
          grant_type: "client_credentials",
          client_id: app.config.clientId,
          client_secret: app.secret.clientSecret,
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In [Action1](https://app.action1.com/), go to **Configuration › API Credentials** and create a new client ID and secret. See the [API docs](https://www.action1.com/api-documentation/) for details.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "configuration", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.action1.com/api/3.0/organizations",
  },
});
